import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAutoResizeToMax]'
})
export class AutoResizeToMax {
  @HostListener(":input")
  public onInput() {
    this.resize();
  }

  constructor(private elem: ElementRef<HTMLTextAreaElement>) {
    this.elem.nativeElement.style.height = "42px";
  }

  public resize() {
    this.elem.nativeElement.style.height = '42px';
    this.elem.nativeElement.style.height = `${this.elem.nativeElement.scrollHeight + 2}px`;
  }
}